import { render, staticRenderFns } from "./ArticlePage.vue?vue&type=template&id=561d6bc8&scoped=true"
import script from "./ArticlePage.vue?vue&type=script&lang=js"
export * from "./ArticlePage.vue?vue&type=script&lang=js"
import style0 from "./ArticlePage.vue?vue&type=style&index=0&id=561d6bc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561d6bc8",
  null
  
)

export default component.exports